module.exports = __webpack_public_path__ + "img/home000.58be64e9.webp";